export const STATUS_API_CALL_INTERVAL = 10000
export const PAYOUT_STATUS_API_CALL_INTERVAL = 10000
export const UPDATE_PAYMENT_STATUS_SUMMARY_API_CALL_INTERVAL = 15500
export const UPDATE_PAYMENT_STATUS_SUMMARY_API_CALL_INTERVAL_PAYOUT = 31000
export const ZERO_SECONDS = 0
export const CHANNEL_API_CALL_INTERVAL = 15500
export const CURRENCIES_STALE_TIME = 10 * (60 * 1000)
export const CURRENCIES_CACHE_TIME = 15 * (60 * 1000)
export const TOAST_DURATION = 90000
export const DEBOUNCE_DURATION = 500
export const FINGERPRINT_CACHE_TIME = 86400

export const reactQueryKeys = {
  summary: () => ['summary'],
  useUpdatePaymentStatusSummary: () => ['useUpdatePaymentStatusSummary'],
  useValdateAddress: () => ['useValdateAddress'],
  rate: () => ['rate'],
  currencies: () => ['currencies'],
  networks: (networkName: string) => ['networks', networkName],
  linkToken: (userId: string, networkId: string) => ['linkToken', userId, networkId],
}

export const MESH_CONNECT_KEY = 'x-cd-mesh-tkns'
export const MESH_CONNECT_DEFAULT_NETWORK_ID = 'e3c7fdd8-b1fc-4e51-85ae-bb276e075611'
export const MIN_SCREEN_HEIGHT_PROGRESS_BAR = 767
export const MIN_SCREEN_WIDTH_PROGRESS_BAR = 640
export const FINGERPRINT_ENABLED = process.env.NEXT_PUBLIC_FINGERPRINT_ENABLED === 'enabled'
export const BVNK = process.env.NEXT_PUBLIC_BRAND === 'bvnk'
export const MESH_USE_DEFAULT_NETWORK = true
